module.exports = __webpack_public_path__ + "img/icon-credit.6f0c5fec.png";